/* ---- Mobile nav + sub-menu accordion (isolated) ---- */
(function () {
  try {
    var toggle = document.querySelector('[data-nav-toggle]');
    var nav = document.querySelector('[data-nav]');
    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        var open = nav.classList.toggle('open');
        document.body.classList.toggle('nav-open', open);
        document.documentElement.style.overflow = open ? 'hidden' : '';
        document.body.style.overflow = open ? 'hidden' : '';
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
    // close menu when a real link (not a chevron) is tapped
    if (nav) {
      nav.querySelectorAll('a[href]').forEach(function (a) {
        a.addEventListener('click', function (e) {
          if (e.target.closest('[data-sub-toggle]')) return;
          nav.classList.remove('open');
          document.body.classList.remove('nav-open');
          document.documentElement.style.overflow = '';
          document.body.style.overflow = '';
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
        });
      });
    }
    // sub-menu accordion (mobile only — the chevron button)
    document.querySelectorAll('[data-sub-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (window.matchMedia('(min-width:990px)').matches) return; // desktop = hover, ignore
        e.preventDefault();
        e.stopPropagation();
        var li = btn.closest('.nav-item');
        if (!li) return;
        var isOpen = li.classList.toggle('sub-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  } catch (e) { if (window.console) console.warn('nav', e); }
})();

/* ---- Variant selection on product page (isolated) ---- */
(function () {
  try {
    var variantsScript = document.querySelector('[data-variants-json]');
    if (!variantsScript) return;
    var variants = JSON.parse(variantsScript.textContent || '[]');
    var selects = Array.prototype.slice.call(document.querySelectorAll('[data-option-select]'));
    var idInput = document.querySelector('[data-variant-id]');
    selects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        var chosen = selects.map(function (s) { return s.value; });
        var match = variants.find(function (v) {
          return chosen.every(function (val, i) { return v.options[i] === val; });
        });
        if (match && idInput) idInput.value = match.id;
      });
    });
  } catch (e) { if (window.console) console.warn('variants', e); }
})();

/* ---- Predictive search ---- */
(function () {
  try {
    var openBtn = document.querySelector('[data-search-open]');
    var overlay = document.querySelector('[data-search-overlay]');
    if (!openBtn || !overlay) return;
    var input = overlay.querySelector('[data-search-input]');
    var results = overlay.querySelector('[data-search-results]');
    var timer;
    openBtn.addEventListener('click', function () { overlay.hidden = false; input.focus(); });
    overlay.querySelector('[data-search-close]').addEventListener('click', function () { overlay.hidden = true; });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') overlay.hidden = true; });
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var lang = document.documentElement.lang;
            var items = (data.resources && data.resources.results.products) || [];
            if (!items.length) {
              results.innerHTML = '<p class="search-none">' + (lang === 'lv' ? 'Nekas nav atrasts' : lang === 'ru' ? 'Ничего не найдено' : 'No results') + '</p>';
              return;
            }
            var hits = items.map(function (p) {
              var type = p.type ? '<span class="search-hit-type">' + p.type + '</span>' : '';
              return '<a class="search-hit" href="' + p.url + '">' +
                (p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '" width="46" height="46" loading="lazy" alt="">' : '<span class="search-hit-noimg"></span>') +
                '<span class="search-hit-info"><span class="search-hit-title">' + p.title + '</span>' + type + '</span>' +
                '<span class="search-hit-price">' + (p.price ? '€' + p.price : '') + '</span></a>';
            }).join('');
            var seeAll = (lang === 'lv' ? 'Skatīt visus rezultātus' : lang === 'ru' ? 'Показать все результаты' : 'See all results');
            results.innerHTML = hits + '<a class="search-seeall" href="/search?q=' + encodeURIComponent(q) + '">' + seeAll + ' &rarr;</a>';
          }).catch(function () {});
      }, 220);
    });
  } catch (e) { if (window.console) console.warn(e); }
})();

/* ---- Recently viewed (product pages) ---- */
(function () {
  try {
    var KEY = 'vesper_recent';
    var meta = document.querySelector('[data-product-meta]');
    var list = [];
    try { list = JSON.parse(window.localStorage.getItem(KEY) || '[]'); } catch (e) {}
    if (meta) {
      var p = JSON.parse(meta.textContent);
      list = list.filter(function (x) { return x.handle !== p.handle; });
      list.unshift(p);
      list = list.slice(0, 8);
      try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
      var box = document.querySelector('[data-recently]');
      var grid = document.querySelector('[data-recently-grid]');
      var others = list.filter(function (x) { return x.handle !== p.handle; }).slice(0, 4);
      if (box && grid && others.length) {
        box.hidden = false;
        grid.innerHTML = others.map(function (x) {
          return '<article class="card"><a class="card-media" href="' + x.url + '">' +
            (x.image ? '<img src="' + x.image + '" loading="lazy" alt="">' : '') +
            '</a><div class="card-body"><h3 class="card-title"><a href="' + x.url + '">' + x.title + '</a></h3>' +
            '<div class="price"><span class="price-now">' + x.price + '</span></div></div></article>';
        }).join('');
      }
    }
  } catch (e) { if (window.console) console.warn(e); }
})();

/* ---- Editorial scroll reveal ---- */
(function () {
  try {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var targets = document.querySelectorAll('.card, .tile, .step, .section-head, .band-text, .band-img, .hero-inner > *');
    if (!('IntersectionObserver' in window) || !targets.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    targets.forEach(function (el, i) {
      el.classList.add('reveal');
      el.style.transitionDelay = Math.min((i % 8) * 55, 330) + 'ms';
      io.observe(el);
    });
  } catch (e) { if (window.console) console.warn(e); }
})();

/* ================= CART DRAWER + UPSELL ================= */
(function () {
  try {
    var drawer = document.querySelector('[data-cart-drawer]');
    var scrim = document.querySelector('[data-cart-scrim]');
    if (!drawer) return;
    var lang = document.documentElement.lang || 'en';
    var T = (window.VESPER_CART_STRINGS) || {};
    var money = function (c) { return '€' + (c / 100).toFixed(2); };

    function open() { drawer.classList.add('open'); scrim.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; document.documentElement.style.overflow = 'hidden'; }
    function close() { drawer.classList.remove('open'); scrim.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; document.documentElement.style.overflow = ''; }
    scrim.addEventListener('click', close);
    drawer.querySelector('[data-cart-close]').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    var linesEl = drawer.querySelector('[data-cart-lines]');
    var emptyEl = drawer.querySelector('[data-cart-empty]');
    var footEl = drawer.querySelector('[data-cart-foot]');
    var totalEl = drawer.querySelector('[data-cart-total]');
    var countEl = drawer.querySelector('[data-cart-count-label]');
    var shipBar = drawer.querySelector('[data-ship-bar]');
    var threshold = parseFloat(shipBar && shipBar.dataset.threshold || '50') * 100;

    function render(cart) {
      var headerCount = document.querySelector('.cart-count');
      if (headerCount) headerCount.textContent = cart.item_count;
      countEl.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
      if (!cart.item_count) {
        linesEl.innerHTML = ''; emptyEl.hidden = false; footEl.hidden = true;
        shipBar.hidden = true; drawer.querySelector('[data-upsell]').hidden = true; return;
      }
      emptyEl.hidden = true; footEl.hidden = false;
      linesEl.innerHTML = cart.items.map(function (it) {
        return '<div class="drawer-line" data-key="' + it.key + '">' +
          '<img src="' + (it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, '_120x$1$2') : '') + '" alt="" loading="lazy">' +
          '<div class="drawer-line-info"><div class="drawer-line-title">' + it.product_title + '</div>' +
          (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="drawer-line-meta">' + it.variant_title + '</div>' : '') +
          '<div class="qty-step"><button data-minus aria-label="-">−</button><span>' + it.quantity + '</span><button data-plus aria-label="+">+</button></div></div>' +
          '<div class="drawer-line-price">' + money(it.final_line_price) + '</div></div>';
      }).join('');
      totalEl.textContent = money(cart.total_price);

      shipBar.hidden = false;
      var fill = shipBar.querySelector('[data-ship-fill]');
      var msg = shipBar.querySelector('[data-ship-msg]');
      if (cart.total_price >= threshold) {
        shipBar.classList.add('ship-bar--done');
        msg.innerHTML = '<strong>' + (T.free_ship_done || 'Free delivery unlocked') + '</strong>';
        fill.style.width = '100%';
      } else {
        shipBar.classList.remove('ship-bar--done');
        var rem = ((threshold - cart.total_price) / 100).toFixed(2);
        msg.innerHTML = (T.free_ship || 'You are €{remaining} away from free delivery').replace('{remaining}', '<strong>€' + rem + '</strong>');
        fill.style.width = Math.min(100, cart.total_price / threshold * 100) + '%';
      }
      bindQty();
    }

    function bindQty() {
      linesEl.querySelectorAll('.drawer-line').forEach(function (line) {
        var key = line.dataset.key;
        var qty = parseInt(line.querySelector('.qty-step span').textContent, 10);
        line.querySelector('[data-plus]').onclick = function () { change(key, qty + 1); };
        line.querySelector('[data-minus]').onclick = function () { change(key, qty - 1); };
      });
    }
    function change(key, q) {
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) })
        .then(function (r) { return r.json(); }).then(render);
    }
    function refresh(openAfter) {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { render(c); loadUpsell(); if (openAfter) open(); });
    }

    var upsellWrap = drawer.querySelector('[data-upsell]');
    var upsellRow = drawer.querySelector('[data-upsell-row]');
    var upsellLoaded = false;
    function loadUpsell() {
      if (upsellLoaded) return; upsellLoaded = true;
      var raw = document.getElementById('upsell-handles');
      var handles = raw ? raw.textContent.replace(/"/g, '').split(',').map(function (s) { return s.trim(); }).filter(Boolean) : [];
      if (!handles.length) return;
      Promise.all(handles.slice(0, 6).map(function (h) {
        return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (prods) {
        prods = prods.filter(Boolean);
        if (!prods.length) return;
        upsellWrap.hidden = false;
        upsellRow.innerHTML = prods.map(function (p) {
          var v = p.variants[0];
          return '<div class="upsell-card"><img src="' + (p.featured_image || '') + '" alt="" loading="lazy">' +
            '<div class="t">' + p.title + '</div><div class="p">' + money(v.price) + '</div>' +
            '<button class="upsell-add" data-add="' + v.id + '">+ ' + (T.add || 'Add') + '</button></div>';
        }).join('');
        upsellRow.querySelectorAll('[data-add]').forEach(function (b) {
          b.onclick = function () { fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: b.dataset.add, quantity: 1 }) }).then(function () { refresh(false); }); };
        });
      });
    }

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"], form[data-ajax-add]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[type=submit]');
      if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = '…'; }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(serialize(form)) })
        .then(function (r) { return r.json(); })
        .then(function () { refresh(true); })
        .finally(function () { if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label; } });
    });
    function serialize(form) {
      var o = {}; new FormData(form).forEach(function (v, k) { o[k] = v; });
      return { id: o.id, quantity: o.quantity || 1 };
    }

    document.querySelectorAll('.cart-link, [data-cart-open]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); refresh(true); });
    });

    refresh(false);
  } catch (e) { if (window.console) console.warn(e); }
})();

/* ============== DELIVERY SLOT (6h rule, LV hours) ============== */
(function () {
  try {
    var el = document.querySelector('[data-slot-text]');
    if (!el) return;
    var S = window.VESPER_SLOT_STRINGS || {};
    var now = new Date();
    var lv = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Riga' }));
    var h = lv.getHours(), day = lv.getDay();
    var closeH = day === 0 ? 18 : 20;
    var ready = h + 6;
    var msg;
    if (h >= 10 && ready <= closeH) {
      var from = ready, to = Math.min(ready + 2, closeH);
      msg = (S.today || 'Order now — delivered today {from}:00–{to}:00').replace('{from}', from).replace('{to}', to);
    } else {
      msg = (S.tomorrow || 'Order now — delivered tomorrow from 12:00');
    }
    el.textContent = msg;
  } catch (e) { if (window.console) console.warn(e); }
})();

/* ================= GIFT BUILDER ================= */
(function () {
  try {
    var root = document.querySelector('[data-gift]');
    if (!root) return;
    var money = function (c) { return '€' + (c / 100).toFixed(2); };
    var linesEl = root.querySelector('[data-gift-lines]');
    var totalEl = root.querySelector('[data-gift-total]');
    var addBtn = root.querySelector('[data-gift-add]');
    var emptyTxt = linesEl.innerHTML;

    root.querySelectorAll('.gift-opt').forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        e.preventDefault();
        var step = opt.closest('.gift-step');
        step.querySelectorAll('.gift-opt').forEach(function (o) { o.classList.remove('sel'); });
        var required = step.dataset.required === 'true';
        if (opt.dataset.sel === '1' && !required) { opt.dataset.sel = ''; }
        else { step.querySelectorAll('.gift-opt').forEach(function (o) { o.dataset.sel = ''; }); opt.classList.add('sel'); opt.dataset.sel = '1'; }
        sync();
      });
    });

    function chosen() {
      var out = [];
      root.querySelectorAll('.gift-step').forEach(function (step) {
        var sel = step.querySelector('.gift-opt[data-sel="1"]');
        if (sel) out.push({ vid: sel.dataset.vid, name: sel.dataset.name, price: parseInt(sel.dataset.price, 10) });
      });
      return out;
    }
    function sync() {
      var items = chosen();
      if (!items.length) { linesEl.innerHTML = emptyTxt; totalEl.textContent = money(0); addBtn.disabled = true; return; }
      var total = 0;
      linesEl.innerHTML = items.map(function (it) {
        total += it.price;
        return '<div class="gift-sum-line"><span>' + it.name + '</span><b>' + money(it.price) + '</b></div>';
      }).join('');
      totalEl.textContent = money(total);
      var ok = true;
      root.querySelectorAll('.gift-step[data-required="true"]').forEach(function (s) { if (!s.querySelector('.gift-opt[data-sel="1"]')) ok = false; });
      addBtn.disabled = !ok;
    }
    addBtn.addEventListener('click', function () {
      var items = chosen();
      if (!items.length) return;
      addBtn.disabled = true; addBtn.textContent = '…';
      var payload = { items: items.map(function (it) { return { id: it.vid, quantity: 1, properties: { '_gift_set': 'yes' } }; }) };
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
        .then(function () {
          var cartIcon = document.querySelector('.cart-link');
          if (cartIcon) cartIcon.click();
        });
    });
  } catch (e) { if (window.console) console.warn(e); }
})();

/* ================= RECIPE BUY ================= */
(function () {
  try {
    var root = document.querySelector('[data-recipe-buy]');
    if (!root) return;
    function openCart(){ var c=document.querySelector('.cart-link'); if(c) c.click(); }
    root.querySelectorAll('[data-add-one]').forEach(function (b) {
      b.addEventListener('click', function () {
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: b.dataset.addOne, quantity: 1 }) }).then(openCart);
      });
    });
    var all = root.querySelector('[data-recipe-add-all]');
    if (all) all.addEventListener('click', function () {
      var ids = [].map.call(root.querySelectorAll('[data-vid]'), function (r) { return { id: r.dataset.vid, quantity: 1 }; });
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: ids }) }).then(openCart);
    });
  } catch (e) { if (window.console) console.warn(e); }
})();
